import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LotsTradeChart = ({ data }) => {
  const [Series, setSeries] = useState([
    {
      name: "Trades per day",
      type: "line",
      data: [],
    },
  ]);
  const [Option, setOption] = useState({
    responsive: [
      {
        breakpoint: 425,
        options: {
          chart: {
            height: 350,
            width: 300,
          },
        },
      },
      {
        breakpoint: 377,
        options: {
          chart: {
            height: 300,
            width: 250,
          },
        },
      },
    ],
    fill: {
      opacity: 1,
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    colors: ["#FD504F"],
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    labels:
      (data && Object.keys(data.date).map((info) => data.date[info])) || [],
    xaxis: {
      // type: "datetime",
      categories: [],
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        seriesName: "Trades per day",
        title: {
          text: "Trades per day",
          style: {
            fontSize: 14,
            fontWeight: 700,
            color: "#ffffff",
          },
        },
        labels: {
          formatter: (value) => {
            return Number(value).toFixed(2);
          },
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },

      // type: 'datetime',
    ],
    // tooltip: {
    //   x: {
    //     show: true,
    //   },
    //   style: {
    //     fontSize: "14px",
    //     fontWeight: "700",
    //   },
    //   custom: function ({
    //     series,
    //     seriesIndex,
    //     dataPointIndex,
    //     optionsIndex,
    //     xaxisPointIndex,
    //     categoriesPointIndex,
    //     options,
    //     xaxis,
    //     w,
    //   }) {
    //     return (
    //       '<div class="arrow_box">' +
    //       '<div class="Annotation-box Date">' +
    //       "<div>" +
    //       "</div>" +
    //       "<span>" +
    //       series[seriesIndex][dataPointIndex] +
    //       "</span>" +
    //       "</div>" +
    //       "<div>" +
    //       `<svg width="150" height="1" viewBox="0 0 150 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                          <line x1="0.5" y1="0.5" x2="149.5" y2="0.5" stroke="url(#paint0_radial_430_8036)" strokeLinecap="round"/>
    //                          <defs>
    //                          <radialGradient id="paint0_radial_430_8036" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(77.9279 1) rotate(180) scale(77.9279 24238.7)">
    //                          <stop offset="0.42336" stopColor="white"/>
    //                          <stop offset="1" stopColor="white" stopOpacity="0"/>
    //                          </radialGradient>
    //                          </defs>
    //                          </svg>` +
    //       `</div>` +
    //       '<div class="Annotation-box Green mbb-5">' +
    //       "<div>" +
    //       "Trades per day - " +
    //       "</div>" +
    //       "<span>" +
    //       series[seriesIndex][dataPointIndex] +
    //       "</span>" +
    //       "</div>" +
    //       "</div>"
    //     );
    //   },
    // },
  });

  useEffect(() => {
    const LotsArr =
      data &&
      data.lots &&
      Object.keys(data.lots).map((info) => data.lots[info]);

    setSeries([
      {
        name: "Trades per day",
        type: "line",
        data: LotsArr,
      },
    ]);

    setOption({
      ...Option,
      labels:
        (data &&
          data.date &&
          Object.keys(data.date).map((info) => data.date[info])) ||
        [],
    });
  }, [data]);

  return (
    <div id="chart">
      <ReactApexChart options={Option} series={Series} height={250} />
    </div>
  );
};
export default LotsTradeChart;
